import { getFullUrl } from 'hubspot-url-utils';
export const getBusinessBoxUrl = (portalId, onboardingUrl, hublet) => {
  const encodedOnboardingUrl = encodeURIComponent(onboardingUrl);
  return `${getFullUrl('app', {
    hubletOverride: hublet
  })}/business-in-a-box/${portalId}/?onboardingUrl=${encodedOnboardingUrl}`;
};